/** Build a stable dot-separated data-testid: `{module}.{feature}.{surface}.{element}` */
export function buildTestId(
  module: string,
  feature: string,
  surface: string,
  element: string
): string {
  return [module, feature, surface, element]
    .map((part) =>
      part
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
    )
    .filter(Boolean)
    .join(".");
}

/** Modal footer / wizard actions using an existing debug surfaceId. */
export function modalTestId(surfaceId: string, action: string): string {
  return `${surfaceId}.${action}`;
}

/** Form control inside a modal/page: `{surfaceId}.field.{fieldName}`. */
export function fieldTestId(surfaceId: string, fieldName: string): string {
  const normalizedField = fieldName
    .trim()
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();
  return `${surfaceId}.field.${normalizedField}`;
}

export function modulePageTestId(
  module: string,
  feature: string,
  action: string
): string {
  return buildTestId(module, feature, "page", action);
}

export function moduleTableTestId(
  module: string,
  feature: string,
  action: string
): string {
  return buildTestId(module, feature, "table", action);
}

const ACADEMIES = "academies";

export function academyPageTestId(feature: string, action: string): string {
  return modulePageTestId(ACADEMIES, feature, action);
}

export function academyTableTestId(feature: string, action: string): string {
  return moduleTableTestId(ACADEMIES, feature, action);
}
